import React, { useContext } from 'react';
import Chevron from '../../foundations/pictograms/chevron_right.svg';
import { textBodyLarge } from '../../styles/typography';
import { classNames } from '../../utils/style';
import { ButtonV2 } from '../ButtonV2';
import { CarouselContext, CarouselContextType } from './CarouselContext';

type PaginationArrowProps = {
  className?: string;
  numberHidden?: boolean;
  isItemsCentered?: boolean;
};

export const PaginationArrow = ({
  className,
  numberHidden,
  isItemsCentered,
}: PaginationArrowProps) => {
  const {
    elementSelected,
    classNamePagination,
    nbElement,
    isLoop,
    isDark,
    onClickNext,
    onClickPrev,
  } = useContext<CarouselContextType>(CarouselContext);
  const disabledRightState =
    (isItemsCentered
      ? elementSelected === nbElement - 1
      : elementSelected === nbElement - 3) && !isLoop;
  const disabledLeftState = elementSelected === 0 && !isLoop;
  const disabledAllStates = disabledRightState && disabledLeftState;

  return (
    <div
      className={classNames(
        className,
        'PaginationArrow flex flex-row items-center justify-end',
        classNamePagination,
      )}
    >
      {!numberHidden && (
        <span
          className={classNames(
            isDark ? 'text-neutral-1' : 'text-neutral-101',
            'mr-40',
            textBodyLarge,
          )}
        >
          {((elementSelected || 0) + 1).toLocaleString('fr-Fr', {
            minimumIntegerDigits: 2,
          })}{' '}
          /{' '}
          {nbElement.toLocaleString('fr-Fr', {
            minimumIntegerDigits: 2,
          })}
        </span>
      )}
      <ButtonV2
        variant="secondary"
        onClick={onClickPrev}
        isDisabled={disabledLeftState}
        className={classNames(
          'mr-16 !min-h-[48px] rounded-full !border-none !px-12 shadow-none',
          disabledLeftState
            ? 'bg-lang-31 text-silver-100'
            : '!bg-neutral-21 text-navy-40',
          disabledAllStates && 'bg-transparent text-transparent',
        )}
        aria-label={'previous'}
      >
        <Chevron
          className={classNames(
            'h-24 w-24 rotate-180',
            disabledLeftState ? 'fill-[#D1DAE6]' : 'fill-[#768699]',
            disabledAllStates && 'fill-none',
          )}
        />
      </ButtonV2>
      <ButtonV2
        variant="secondary"
        title="next"
        isDisabled={disabledRightState}
        className={classNames(
          '!min-h-[48px] rounded-full !border-none !px-12 shadow-none',
          disabledRightState
            ? 'bg-lang-31 text-silver-100'
            : '!bg-neutral-21 text-navy-40',
          disabledAllStates && 'bg-transparent text-transparent',
        )}
        onClick={onClickNext}
        aria-label="next"
      >
        <Chevron
          className={classNames(
            'h-24 w-24',
            disabledRightState ? 'fill-[#D1DAE6]' : 'fill-[#768699]',
            disabledAllStates && 'fill-none',
          )}
        />
      </ButtonV2>
    </div>
  );
};

export default PaginationArrow;
